import runAfterPageLoad from "./runAfterPageLoad";

export default function adminHubPages() {
  runAfterPageLoad(initAdminHubPages);

  function initAdminHubPages() {
    const sliderElemIds = $(".admin-hub-page-hero-slider__element-ids");
    sliderElemIds.select2({
      multiple: true,
      placeholder: "Select and order sliders",
      theme: "bootstrap",
    });
    // src: https://github.com/select2/select2/issues/3004#issuecomment-485821449
    sliderElemIds
      .parent()
      .find("ul")
      .sortable({
        containment: "parent",
        stop: (event, ui) => {
          ui.item
            .parent()
            .children("[title]")
            .each((idx, elem) => {
              const title = $(elem).attr("title");
              const original = $(
                `option:contains('${title}')`,
                sliderElemIds
              ).first();
              original.detach();
              sliderElemIds.append(original);
            });
          sliderElemIds.change();
        },
      });

    const eventSliderElemIds = $(".admin-hub-page-event-slider__element-ids");
    eventSliderElemIds.select2({
      multiple: true,
      placeholder: "Select and order event sliders",
      theme: "bootstrap",
    });
    // src: https://github.com/select2/select2/issues/3004#issuecomment-485821449
    eventSliderElemIds
      .parent()
      .find("ul")
      .sortable({
        containment: "parent",
        stop: (event, ui) => {
          ui.item
            .parent()
            .children("[title]")
            .each((idx, elem) => {
              const title = $(elem).attr("title");
              const original = $(
                `option:contains('${title}')`,
                eventSliderElemIds
              ).first();
              original.detach();
              eventSliderElemIds.append(original);
            });
          eventSliderElemIds.change();
        },
      });

    $(".admin-hub-page__new-teaser-container").on("click", addTeaserEvents);
    $(".admin-hub-page__new-description-container").on(
      "click",
      addTeaserDescription
    );
    $(".admin-hub-page__new-cms-page-container").on("click", addTeaserCmsPage);
    $(".admin-hub-page__new-hero-slider-container").on("click", addTeaserHeroSlider);
    $(".admin-hub-page__new-event-slider-container").on(
      "click",
      addTeaserEventSlider
    );
    $(".admin-hub-page__new-self-quiz-container").on("click", addSelfQuiz);
    $(".admin-hub-page-teaser:not(.hidden)").each((idx, item) => {
      initializeNewEventHandlers($(item));
      initializeNewSelect2($(item));
      initializeTinyMCE(item.id);
    });

    $(".admin-hub-page-restrictions").each((idx, item) => {
      initializeUserAttributeRestrictions(item);
    });

    $("input[data-checkbox-collapsable]").on("change", showCollapsableExpand);

    recalculateTeasersPositions();
  }
}

function initializeNewEventHandlers(elem) {
  elem.find(".admin-hub-page-form-teaser-delete").on("click", deleteTeaser);
  elem.find(".admin-hub-page-form-teaser-up").on("click", moveUpTeaser);
  elem.find(".admin-hub-page-form-teaser-down").on("click", moveDownTeaser);

  elem.find(".admin-hub-page-filter__delete").on("click", deleteFilter);
  elem.find(".admin-hub-page-filter__add").on("click", addFilter);
}

function initializeNewSelect2(elem) {
  const subjects = elem
    .find(".admin-hub-page-filter:not(.hidden)")
    .find(".admin-hub-page-filter__subject:not(.select2-initialized)");
  subjects.select2({
    theme: "bootstrap",
  });
  subjects.addClass("select2-initialized");
  subjects.on("change", switchFilterValues);

  const operators = elem
    .find(".admin-hub-page-filter:not(.hidden)")
    .find(".admin-hub-page-filter__operator:not(.select2-initialized)");
  operators.select2({
    theme: "bootstrap",
  });
  operators.addClass("select2-initialized");

  const values = elem
    .find(".admin-hub-page-filter:not(.hidden)")
    .find(".admin-hub-page-filter__values:not(.select2-initialized)");
  values.select2({
    multiple: true,
    placeholder: "Select an option",
    theme: "bootstrap",
  });
  // need to preselect values manually
  const selectedIds = $.map(values.find("option:selected"), (option) =>
    $(option).val()
  );
  if (selectedIds.length > 0) {
    // https://stackoverflow.com/questions/40858350/select2-multiple-select-default-selections-not-working
    values.val(selectedIds).trigger("change");
  } else {
    // select2 does weird shit in multiple selects:
    // https://stackoverflow.com/questions/49943362/select2-multi-select-blank-option-always-selected/54809736#54809736
    values.val(null).trigger("change");
  }
  values.addClass("select2-initialized");
  values.on("change", saveFilterValues);

  // hide values selects for user’s skills
  values.each((idx, item) => {
    const subjectKey = $(item)
      .parents(".row")
      .first()
      .find(".admin-hub-page-filter__subject")
      .first()
      .val();
    if (subjectKey === "booked_by_user" || subjectKey === "competency") {
      $(item).parent("div").addClass("hidden");
    }
  });

  const orderFields = elem.find(
    ".admin-hub-page-order__field:not(.select2-initialized)"
  );
  orderFields.select2({
    theme: "bootstrap",
  });
  orderFields.addClass("select2-initialized");

  const orderDirections = elem.find(
    ".admin-hub-page-order__direction:not(.select2-initialized)"
  );
  orderDirections.select2({
    theme: "bootstrap",
  });
  orderDirections.addClass("select2-initialized");

  const cmsPageIds = elem.find(
    ".admin-hub-page-cms_page_id:not(.select2-initialized)"
  );
  cmsPageIds.select2({
    theme: "bootstrap",
  });
  cmsPageIds.addClass("select2-initialized");
}

// teasers

function addTeaserHeroSlider() {
  const newTeaser = $(".admin-hub-page-teaser.hidden[isheroslider]").first();

  if (newTeaser) {
    $(newTeaser).removeClass("hidden");
    $(newTeaser).fadeIn(500);
    $(newTeaser).find(".admin-hub-page-teaser__hidden").val(false);
    initializeNewEventHandlers($(newTeaser));
    initializeNewSelect2($(newTeaser));
  }

  recalculateTeasersPositions();
}

function addTeaserEventSlider() {
  const newTeaser = $(".admin-hub-page-teaser.hidden[iseventslider]").first();

  if (newTeaser) {
    $(newTeaser).removeClass("hidden");
    $(newTeaser).fadeIn(500);
    $(newTeaser).find(".admin-hub-page-teaser__hidden").val(false);
    initializeNewEventHandlers($(newTeaser));
    initializeNewSelect2($(newTeaser));
  }

  recalculateTeasersPositions();
}

function addTeaserCmsPage() {
  const newTeaser = $(".admin-hub-page-teaser.hidden[iscmspage]").first();

  if (newTeaser) {
    $(newTeaser).removeClass("hidden");
    $(newTeaser).fadeIn(500);
    $(newTeaser).find(".admin-hub-page-teaser__hidden").val(false);
    initializeNewEventHandlers($(newTeaser));
    initializeNewSelect2($(newTeaser));
  }

  recalculateTeasersPositions();
}

function addTeaserEvents() {
  const newTeaser = $(".admin-hub-page-teaser.hidden[isevent]").first();

  if (newTeaser) {
    $(newTeaser).removeClass("hidden");
    $(newTeaser).fadeIn(500);
    $(newTeaser).find(".admin-hub-page-teaser__hidden").val(false);
    initializeNewEventHandlers($(newTeaser));
    initializeNewSelect2($(newTeaser));
  }

  recalculateTeasersPositions();
}

function addTeaserDescription() {
  const newTeaser = $(".admin-hub-page-teaser.hidden[isdescription]").first();

  if (newTeaser) {
    $(newTeaser).removeClass("hidden");
    $(newTeaser).fadeIn(500);
    $(newTeaser).find(".admin-hub-page-teaser__hidden").val(false);
    initializeNewEventHandlers($(newTeaser));
    initializeTinyMCE(newTeaser.attr("id"));
  }

  recalculateTeasersPositions();
}

function addSelfQuiz() {
  const newTeaser = $(".admin-hub-page-teaser.hidden[isquiz]").first();

  if (newTeaser) {
    $(newTeaser).removeClass("hidden");
    $(newTeaser).fadeIn(500);
    $(newTeaser).find(".admin-hub-page-teaser__hidden").val(false);
    initializeNewEventHandlers($(newTeaser));
    initializeNewSelect2($(newTeaser));
  }

  recalculateTeasersPositions();
}

function deleteTeaser(event) {
  $(event.target).parents(".admin-hub-page-teaser").remove();
  recalculateTeasersPositions();
}

function recalculateTeasersPositions() {
  $(".admin-hub-page-teaser__position").each((idx, elem) => {
    $(elem).val(idx + 1);
  });
}

function moveUpTeaser(event) {
  const teaser = $(event.target).parents(".admin-hub-page-teaser");
  const previousTeaser = teaser.prev();
  if (previousTeaser.length === 0) {
    return false;
  }

  teaser.detach();
  previousTeaser.before(teaser);
  recalculateTeasersPositions();
  if (teaser[0].attributes[2].name === "isdescription") {
    // eslint-disable-next-line
    tinyMCE.remove(`textarea.tinyMCEDescription_${teaser[0].id}`);
    initializeTinyMCE(teaser[0].id);
  }

  return true;
}

function moveDownTeaser(event) {
  const teaser = $(event.target).parents(".admin-hub-page-teaser");
  const nextTeaser = teaser.next();

  if (nextTeaser.length === 0) {
    return false;
  }

  teaser.detach();
  nextTeaser.after(teaser);
  recalculateTeasersPositions();
  if (teaser[0].attributes[2].name === "isdescription") {
    // eslint-disable-next-line
    tinyMCE.remove(`textarea.tinyMCEDescription_${teaser[0].id}`);
    initializeTinyMCE(teaser[0].id);
  }

  return true;
}

// filters
function addFilter(event) {
  const teaser = $(event.target).parents(".admin-hub-page-teaser");
  const newFilter = teaser.find(".admin-hub-page-filter.hidden").first();

  if (newFilter) {
    $(newFilter).removeClass("hidden");
    $(newFilter).fadeIn(500);
    initializeNewSelect2($(teaser));
    $(newFilter).find(".admin-hub-page-filter__hidden").val(false);
    setFilterValues(newFilter);
  }
}

function saveFilterValues(event) {
  const filter = $(event.target).parents(".admin-hub-page-filter");
  const subject = filter.find(".admin-hub-page-filter__subject").first();
  const values = filter.find(".admin-hub-page-filter__values").first();
  const selectedIds = $.map(values.find("option:selected"), (option) =>
    $(option).val()
  );
  const data = values.data("selected");
  data[subject.val()] = selectedIds;
  values.data("selected", data);
}

function setFilterValues(filter) {
  const subject = filter.find(".admin-hub-page-filter__subject").first();
  const values = filter.find(".admin-hub-page-filter__values").first();
  const options = values.data("options");
  const selected = values.data("selected");

  values.find("option").remove();
  if (options[subject.val()] !== "HIDE") {
    values.parent("div").removeClass("hidden");
    values.append(options[subject.val()]);
  } else {
    values.parent("div").addClass("hidden");
  }
  values.val(selected[subject.val()]).trigger("change");
}

function switchFilterValues(event) {
  const filter = $(event.target).parents(".admin-hub-page-filter");
  setFilterValues(filter);
}

function deleteFilter(event) {
  $(event.target).parents(".admin-hub-page-filter").remove();
}

// user attribute restrictions
function initializeUserAttributeRestrictions(scope) {
  const select = $(scope).find("select[name=attribute_selection]");
  select.select2({
    placeholder: "Select attribute",
    theme: "bootstrap",
  });
  select.addClass("select2-initialized");

  const scopeId = $(scope).closest(".admin-hub-page-teaser").attr("id");

  const used = select.data("used");
  const restrictions = select.data("restrictions");
  if (restrictions) {
    Object.entries(restrictions).forEach((keyValuePair) => {
      $(scope)
        .find(".admin-hub-page-restrictions-container")
        .append(userAttributeRestriction(scopeId, keyValuePair[0], keyValuePair[1]));
      used.push(keyValuePair[0]);
      $(scope)
        .find(
          ".admin-hub-page-restrictions-container .admin-hub-page-restriction__delete"
        )
        .last()
        .on("click", deleteUserAttributeRestriction);
    });
    select.data("used", used);
  }

  $(scope)
    .find(".admin-hub-page-restriction__add")
    .on("click", addUserAttributeRestriction);
}

function userAttributeRestriction(id, name, values) {
  return `<div class="admin-hub-page-restriction">
    <div class="row">
      <div class="col-auto"><label for="hub_page_form_product_teasers_attributes_${id}_user_attribute_restrictions_attributes_${name}">${name}</label></div>
      <div class="col-auto">
	<input class="form-control" name="hub_page_form[product_teasers_attributes][${id}][user_attribute_restrictions_attributes][${name}]" id="hub_page_form_product_teasers_attributes_${id}_user_attribute_restrictions_attributes_${name}" value="${values}">
      </div>
      <div class="col-auto"><div class="admin-hub-page-restriction__delete"><i class="fas fa-trash"></i></div></div>
    </div>
  </div>`;
}

function addUserAttributeRestriction(event) {
  const scope = $(event.target).closest(".admin-hub-page-restrictions");
  const scopeId = $(scope).closest(".admin-hub-page-teaser").attr("id");
  const select = $(scope).find("select[name=attribute_selection]");
  const selected = $(select).find("option:selected").val();
  const used = select.data("used");

  if (used.includes(selected) || selected === "") {
    return;
  }

  used.push(selected);
  select.data("used", used);
  $(scope)
    .find(".admin-hub-page-restrictions-container")
    .append(userAttributeRestriction(scopeId, selected, ""));
  $(scope)
    .find(
      ".admin-hub-page-restrictions-container .admin-hub-page-restriction__delete"
    )
    .last()
    .on("click", deleteUserAttributeRestriction);
}

function deleteUserAttributeRestriction(event) {
  const block = $(event.target).closest(".admin-hub-page-restriction");
  const name = $(block).find("label").text();
  const select = $(block)
    .closest(".admin-hub-page-restrictions")
    .find("select[name=attribute_selection]");
  const used = select.data("used");

  delete used[used.indexOf(name)];
  select.data("used", used);
  block.remove();
}

// tiny mce
function initializeTinyMCE(id) {
  const tinymceConfig = {
    selector: `textarea.tinyMCEDescription_${id}`,
    plugins:
      "  lists link image charmap preview  searchreplace visualblocks code fullscreen insertdatetime media paste code wordcount table",
    toolbar:
      "undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist outdent indent | forecolor backcolor table",
    relative_urls: false,
    color_map: [
      "E20074",
      "Magenta",
      "FFFFFF",
      "White",
      "000000",
      "Black",
      "262626",
      "Gray 38",
      "4B4B4B",
      "Gray 5",
      "6C6C6C",
      "Gray 3",
      "7C7C7C",
      "Gray 2",
      "A4A4A4",
      "Gray 1",
      "D0D0D0",
      "Gray 6",
      "E6E6E6",
      "Gray 230",
      "EDEDED",
      "Gray 4",
      "FFD329",
      "Screen Yellow 100%",
      "FFDE5D",
      "Screen Yellow light",
      "DBAD39",
      "Screen Yellow dark",
      "FF9A1E",
      "Screen Orange 100%",
      "FFB356",
      "Screen Orange light",
      "D48936",
      "Screen Orange dark",
      "53BAF2",
      "Screen Light Blue 100%",
      "7ECBF5",
      "Screen Light Blue light",
      "317CB3",
      "Screen Light Blue dark",
      "1063AD",
      "Screen Dark Blue 100%",
      "529AD6",
      "Screen Dark Blue light",
      "235482",
      "Screen Dark Blue dark",
      "1BADA2",
      "Screen Petrol 100%",
      "65C8C0",
      "Screen Petrol light",
      "218076",
      "Screen Petrol dark",
      "BFCB44",
      "Screen Green 100%",
      "CFD89B",
      "Screen Green light",
      "889130",
      "Screen Green dark",
      "FF55AB",
      "Magenta mid (unofficial)",
      "FFC6E2",
      "Magenta light (unofficial)",
    ],
  };
  // eslint-disable-next-line
  tinyMCE.init(tinymceConfig);
}

function showCollapsableExpand(event) {
  const elem = event.target;
  const collapsableExCheckbox = $(
    $(elem).closest(".form-group").find(".collapse_expandable")[0]
  );
  if ($(elem).is(":checked")) {
    $(collapsableExCheckbox[0]).show();
  } else {
    $(collapsableExCheckbox[0]).hide();
  }
}
